import { render } from "./CorePlatformGridComponent.vue?vue&type=template&id=2dbf83a6"
import script from "./CorePlatformGridComponent.vue?vue&type=script&lang=js"
export * from "./CorePlatformGridComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__